/*
* @Author: tengmaoqing
* @Date:   2018-04-16 14:05:40
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-13 20:39:29
*/

// store.js
import { storeFnCreator } from '@/system/init/init-store';
import basePidConfig from '@/config/pid.config';

basePidConfig.loginType = 'nubia';
basePidConfig.isUseBJTime = true;
basePidConfig.appSecret = 'b7cab12b2b81385dd2cccb8ce67e4998';

const loadConfig = pid => {
  /** 针对pid做部分更改 */
  if (pid === 'xxxx') {
    basePidConfig.TEST_PROTIY = 'xxx';
  }
  return basePidConfig;
};

const initStore = {
  state: {
    pid: 1063
  }
};

export function createStore () {
  return storeFnCreator(loadConfig, initStore);
}
